export const SUBTRACT_PRODUCT = "SUBTRACT_PRODUCT";
export const GET_PRODUCT_LIST_SUCCESS = "GET_PRODUCT_LIST_SUCCESS";
export const GET_PRODUCT_LIST_REQUEST = "GET_PRODUCT_LIST_REQUEST";

export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const SIGNUP_START = "SIGNUP_START";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

export const PHONE_START = "PHONE_START";
export const PHONE_SUCCESS = "PHONE_SUCCESS";
export const PHONE_FAILURE = "PHONE_FAILURE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";

export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOGOUT_CURRENT_USER = "LOGOUT_CURRENT_USER";
export const RESET_PASSWORD = "RESET_PASSWORD";

export const REFRESH_TOKEN_PENDING = "REFRESH_TOKEN_PENDING";
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_ERROR = "REFRESH_TOKEN_ERROR";
export const UNSET_CURRENT_USER = "UNSET_CURRENT_USER";

export const SITE_MANAGER_DATA_START = "SITE_MANAGER_DATA_START";
export const SITE_MANAGER_DATA_SUCCESS = "SITE_MANAGER_DATA_SUCCESS";
export const SITE_MANAGER_DATA_FAILURE = "SITE_MANAGER_DATA_FAILURE";

export const SITES_LIST_DATA_START = "SITES_LIST_DATA_START";
export const SITES_LIST_DATA_SUCCESS = "SITES_LIST_DATA_SUCCESS";
export const SITES_LIST_DATA_FAILURE = "SITES_LIST_DATA_FAILURE";

export const SITES_DATA_START = "SITES_DATA_START";
export const SITES_DATA_SUCCESS = "SITES_DATA_SUCCESS";
export const SITES_DATA_FAILURE = "SITES_DATA_FAILURE";

export const JOB_LIST_DATA_START = "JOB_LIST_DATA_START";
export const JOB_LIST_DATA_SUCCESS = "JOB_LIST_DATA_SUCCESS";
export const JOB_LIST_DATA_FAILURE = "JOB_LIST_DATA_FAILURE";

export const JOB_DATA_START = "JOB_DATA_START";
export const JOB_DATA_SUCCESS = "JOB_DATA_SUCCESS";
export const JOB_DATA_FAILURE = "JOB_DATA_FAILURE";


export const TIPPING_LIST_DATA_START = "TIPPING_LIST_DATA_START";
export const TIPPING_LIST_DATA_SUCCESS = "TIPPING_LIST_DATA_SUCCESS";
export const TIPPING_LIST_DATA_FAILURE = "TIPPING_LIST_DATA_FAILURE";

export const TICKETS_LIST_DATA_START = "TICKETS_LIST_DATA_START";
export const TICKETS_LIST_DATA_SUCCESS = "TICKETS_LIST_DATA_SUCCESS";
export const TICKETS_LIST_DATA_FAILURE = "TICKETS_LIST_DATA_FAILURE";


export const DASHBOARD_DATA_START = "DASHBOARD_DATA_START";
export const DASHBOARD_DATA_SUCCESS = "DASHBOARD_DATA_SUCCESS";
export const DASHBOARD_DATA_FAILURE = "DASHBOARD_DATA_FAILURE";

export const DASHBOARD_MAP_START = "DASHBOARD_MAP_START";
export const DASHBOARD_MAP_SUCCESS = "DASHBOARD_MAP_SUCCESS";
export const DASHBOARD_MAP_FAILURE = "DASHBOARD_MAP_FAILURE";

export const DASHBOARD_SERVICE_START = "DASHBOARD_SERVICE_START";
export const DASHBOARD_SERVICE_SUCCESS = "DASHBOARD_SERVICE_SUCCESS";
export const DASHBOARD_SERVICE_FAILURE = "DASHBOARD_SERVICE_FAILURE";

export const DASHBOARD_SALES_START = "DASHBOARD_SALES_START";
export const DASHBOARD_SALES_SUCCESS = "DASHBOARD_SALES_SUCCESS";
export const DASHBOARD_SALES_FAILURE = "DASHBOARD_SALES_FAILURE";

export const REPORTS_START = "REPORTS_START";
export const REPORTS_SUCCESS = "REPORTS_SUCCESS";
export const REPORTS_FAILURE = "REPORTS_FAILURE";

export const REPORTS_SITE_BREAKDOWN_START = "REPORTS_SITE_BREAKDOWN_START";
export const REPORTS_SITE_BREAKDOWN_SUCCESS = "REPORTS_SITE_BREAKDOWN_SUCCESS";
export const REPORTS_SITE_BREAKDOWN_FAILURE = "REPORTS_SITE_BREAKDOWN_FAILURE";

export const REPORTS_REBATE_BREAKDOWN_START = "REPORTS_REBATE_BREAKDOWN_START";
export const REPORTS_REBATE_BREAKDOWN_SUCCESS = "REPORTS_REBATE_BREAKDOWN_SUCCESS";
export const REPORTS_REBATE_BREAKDOWN_FAILURE = "REPORTS_REBATE_BREAKDOWN_FAILURE";

export const REPORTS_EFFICENCY_LIST_START = "REPORTS_EFFICENCY_LIST_START";
export const REPORTS_EFFICENCY_LIST_SUCCESS = "REPORTS_EFFICENCY_LIST_SUCCESS";
export const REPORTS_EFFICENCY_LIST_FAILURE = "REPORTS_EFFICENCY_LIST_FAILURE";

export const REPORTS_WASTE_EMISSION_START = "REPORTS_WASTE_EMISSION_START";
export const REPORTS_WASTE_EMISSION_SUCCESS = "REPORTS_WASTE_EMISSION_SUCCESS";
export const REPORTS_WASTE_EMISSION_FAILURE = "REPORTS_WASTE_EMISSION_FAILURE";

export const REPORTS_DELIVERIES_START = "REPORTS_DELIVERIES_START";
export const REPORTS_DELIVERIES_SUCCESS = "REPORTS_DELIVERIES_SUCCESS";
export const REPORTS_DELIVERIES_FAILURE = "REPORTS_DELIVERIES_FAILURE";

export const REPORTS_USER_SERVICE_START = "REPORTS_USER_SERVICE_START";
export const REPORTS_USER_SERVICE_SUCCESS = "REPORTS_USER_SERVICE_SUCCESS";
export const REPORTS_USER_SERVICE_FAILURE = "REPORTS_USER_SERVICE_FAILURE";

export const REPORTS_HIRE_BREAKDOWN_START = "REPORTS_HIRE_BREAKDOWN_START";
export const REPORTS_HIRE_BREAKDOWN_SUCCESS = "REPORTS_HIRE_BREAKDOWN_SUCCESS";
export const REPORTS_HIRE_BREAKDOWN_FAILURE = "REPORTS_HIRE_BREAKDOWN_FAILURE";

export const REPORTS_SITE_MOVEMENT_START = "REPORTS_SITE_MOVEMENT_START";
export const REPORTS_SITE_MOVEMENT_SUCCESS = "REPORTS_SITE_MOVEMENT_START";
export const REPORTS_SITE_MOVEMENT_FAILURE = "REPORTS_SITE_MOVEMENT_START";

export const REPORTS_SITE_MOVEMENT_BREAKDOWN_START = "REPORTS_SITE_MOVEMENT_BREAKDOWN_START";
export const REPORTS_SITE_MOVEMENT_BREAKDOWN_SUCCESS = "REPORTS_SITE_MOVEMENT_BREAKDOWN_START";
export const REPORTS_SITE_MOVEMENT_BREAKDOWN_FAILURE = "REPORTS_SITE_MOVEMENT_BREAKDOWN_START";

export const JOBS_META_START = "JOBS_META_START";
export const JOBS_META_SUCCESS = "JOBS_META_SUCCESS";
export const JOBS_META_FAILURE = "JOBS_META_FAILURE";

export const SITE_MOVEMENTS = "SITE_MOVEMENTS";
export const SITE_MOVEMENT_SUCCESS = "SITE_MOVEMENT_SUCCESS";
export const SITE_MOVEMENT_FAILURE = "SITE_MOVEMENT_FAILURE";

export const SITE_MOVEMENTS_DETAIL = "SITE_MOVEMENTS_DETAIL";
export const SITE_MOVEMENT_DETAIL_SUCCESS = "SITE_MOVEMENT_DETAIL_SUCCESS";
export const SITE_MOVEMENT_DETAIL_FAILURE = "SITE_MOVEMENT_DETAIL_FAILURE";

export const REPORT_EMISSIONS_START = "REPORT_EMISSIONS_START";
export const REPORT_EMISSIONS_SUCCESS = "REPORT_EMISSIONS_SUCCESS";
export const REPORT_EMISSIONS_FAILURE = "REPORT_EMISSIONS_FAILURE";

export const REPORT_EMISSIONS_SERVICE_START = "REPORT_EMISSIONS_SERVICE_START";
export const REPORT_EMISSIONS_SERVICE_SUCCESS = "REPORT_EMISSIONS_SERVICE_SUCCESS";
export const REPORT_EMISSIONS_SERVICE_FAILURE = "REPORT_EMISSIONS_SERVICE_FAILURE";

export const REPORT_WASTE_EMISSIONS_START = "REPORT_WASTE_EMISSIONS_START";
export const REPORT_WASTE_EMISSIONS_SUCCESS = "REPORT_WASTE_EMISSIONS_SUCCESS";
export const REPORT_WASTE_EMISSIONS_FAILURE = "REPORT_WASTE_EMISSIONS_FAILURE";


export const REPORT_WASTE_EMISSIONS_SERVICE_START = "REPORT_WASTE_EMISSIONS_SERVICE_START";
export const REPORT_WASTE_EMISSIONS_SERVICE_SUCCESS = "REPORT_WASTE_EMISSIONS_SERVICE_SUCCESS";
export const REPORT_WASTE_EMISSIONS_SERVICE_FAILURE = "REPORT_WASTE_EMISSIONS_SERVICE_FAILURE";

export const REPORT_EMISSIONS_SITE_BREAKDOWN_START = "REPORT_EMISSIONS_SITE_BREAKDOWN_START";
export const REPORT_EMISSIONS_SITE_BREAKDOWN_SUCCESS = "REPORT_EMISSIONS_SITE_BREAKDOWN_SUCCESS";
export const REPORT_EMISSIONS_SITE_BREAKDOWN_FAILURE = "REPORT_EMISSIONS_SITE_BREAKDOWN_FAILURE";

export const GET_REPORT_VEHICLE_START = "GET_REPORT_VEHICLE_START";
export const GET_REPORT_VEHICLE_SUCCESS = "GET_REPORT_VEHICLE_SUCCESS";
export const GET_REPORT_VEHICLE_FAILURE = "GET_REPORT_VEHICLE_FAILURE";

export const LANDFILL_DIVERSION_START = "LANDFILL_DIVERSION_START";
export const LANDFILL_DIVERSION_SUCCESS = "LANDFILL_DIVERSION_SUCCESS";
export const LANDFILL_DIVERSION_FAILURE = "LANDFILL_DIVERSION_FAILURE";

export const GET_PORTFOLIO_START = "GET_PORTFOLIO_START";
export const GET_PORTFOLIO_SUCCESS = "GET_PORTFOLIO_SUCCESS";
export const GET_PORTFOLIO_FAILURE = "GET_PORTFOLIO_FAILURE";

export const GET_WASTE_START = "GET_WASTE_START";
export const GET_WASTE_SUCCESS = "GET_WASTE_SUCCESS";
export const GET_WASTE_FAILURE = "GET_WASTE_FAILURE";

export const GET_TONNAGE_START = "GET_TONNAGE_START";
export const GET_TONNAGE_SUCCESS = "GET_TONNAGE_SUCCESS";
export const GET_TONNAGE_FAILURE = "GET_TONNAGE_FAILURE";

export const GET_WASTE_OF_ENERGY_START = "GET_WASTE_OF_ENERGY_START";
export const GET_WASTE_OF_ENERGY_SUCCESS = "GET_WASTE_OF_ENERGY_SUCCESS";
export const GET_WASTE_OF_ENERGY_FAILURE = "GET_WASTE_OF_ENERGY_FAILURE";

export const GET_RECYCLED_START = "GET_RECYCLED_START";
export const GET_RECYCLED_SUCCESS = "GET_RECYCLED_SUCCESS";
export const GET_RECYCLED_FAILURE = "GET_RECYCLED_FAILURE";


export const GET_RECYCLED_SUPP_START = "GET_RECYCLED_SUPP_START";
export const GET_RECYCLED_SUPP_SUCCESS = "GET_RECYCLED_SUPP_SUCCESS";
export const GET_RECYCLED_SUPP_FAILURE = "GET_RECYCLED_SUPP_FAILURE";

export const LANDFILL_DIVERSION_LIST_START = "LANDFILL_DIVERSION_LIST_START";
export const LANDFILL_DIVERSION_LIST_SUCCESS = "LANDFILL_DIVERSION_LIST_SUCCESS";
export const LANDFILL_DIVERSION_LIST_FAILURE = "LANDFILL_DIVERSION_LIST_FAILURE";

export const REPORTS_SITE_BREAKDOWN_LIST_START = "REPORTS_SITE_BREAKDOWN_LIST_START";
export const REPORTS_SITE_BREAKDOWN_LIST_SUCCESS = "REPORTS_SITE_BREAKDOWN_LIST_SUCCESS";
export const REPORTS_SITE_BREAKDOWN_LIST_FAILURE = "REPORTS_SITE_BREAKDOWN_LIST_FAILURE";

export const SITE_MOVEMENTS_LIST = "SITE_MOVEMENTS_LIST";
export const SITE_MOVEMENT_LIST_SUCCESS = "SITE_MOVEMENT_LIST_SUCCESS";
export const SITE_MOVEMENT_LIST_FAILURE = "SITE_MOVEMENT_LIST_FAILURE";

export const ALL_COUNTERIES_LIST = "ALL_COUNTERIES_LIST";
export const ALL_COUNTERIES_LIST_SUCCESS = "ALL_COUNTERIES_LIST_SUCCESS";
export const ALL_COUNTERIES_LIST_FAILURE = "ALL_COUNTERIES_LIST_FAILURE";

export const ALL_SUPPLIERS = "ALL_SUPPLIERS";
export const ALL_SUPPLIERS_SUCCESS = "ALL_SUPPLIERS_SUCCESS";
export const ALL_SUPPLIERS_FAILURE = "ALL_SUPPLIERS_FAILURE";

export const JOBS_FILTER = "JOBS_FILTER";
export const SITES_FILTER = "SITES_FILTER";

